// import PropTypes from 'prop-types';
import './style.scss';
import PropTypes from 'prop-types';

const AppContent = ({children}) => {
	return <div className="unhab-AppContent">{children}</div>;
};

AppContent.propTypes = {
	children: PropTypes.node,
};

export default AppContent;
